module.exports = __webpack_public_path__ + "img/delete_image.eb691dc9.svg";